import useSafeState from '@restart/hooks/useSafeState';
import styled from 'astroturf';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from './Button';
import Modal from './Modal';
import ModalButtonGroup from './ModalButtonGroup';
import captureException from './utils/captureException';
const Content = /*#__PURE__*/styled('p', null, {
  displayName: "Content",
  styles: require("./Dialog-Content.module.scss"),
  attrs: null,
  vars: []
});
const defaultProps = {
  confirmLabel: React.createElement(FormattedMessage, {
    id: "@bfly/ui:dialog.confirm",
    defaultMessage: "OK"
  }),
  theme: 'primary'
};

function Dialog({
  hideCancel,
  children,
  cancelLabel,
  confirmLabel,
  onCancel,
  show,
  theme,
  title,
  ...props
}) {
  const [status, setStatus] = useSafeState(useState(null));

  const handleConfirm = () => {
    if ('runConfirm' in props) {
      setStatus('pending');
      props.runConfirm().then(data => {
        setStatus('resolved');
        props.onConfirmed(data);
      }, err => {
        setStatus('rejected');
        captureException(err);
      });
    } else {
      props.onConfirmed(true);
    }
  };

  return React.createElement(Modal, {
    onHide: onCancel,
    show: show,
    backdrop: true,
    "data-bni-id": "Dialog"
  }, title && React.createElement(Modal.Header, null, React.createElement(Modal.Title, null, title)), React.createElement(Modal.Body, null, React.createElement(Content, null, children), React.createElement(ModalButtonGroup, null, React.createElement(Button, {
    size: "large",
    busy: status === 'pending',
    theme: theme,
    onClick: handleConfirm
  }, confirmLabel), hideCancel ? React.createElement("span", null) : React.createElement(Button, {
    size: "large",
    theme: "secondary",
    onClick: onCancel,
    disabled: status === 'pending' || status === 'resolved'
  }, cancelLabel || React.createElement(FormattedMessage, {
    id: "@bfly/ui:dialog.cancel",
    defaultMessage: "Cancel"
  })))));
}

Dialog.defaultProps = defaultProps;
export default Dialog;